export const mapInputsToAddressHR = (addressFormInputs) => {
	const { street, houseNumber, apartment, floor, building, addressLine2 } =
		addressFormInputs;

	let base = [street, houseNumber].filter(Boolean).join(' ');

	if (apartment) {
		const apt = apartment.startsWith('/') ? apartment.slice(1) : apartment;
		base += `${base ? '' : ''}/${apt}`;
	}

	const extras = [
		floor ? `${floor}. kat` : null,
		building || null,
		addressLine2 || null,
	].filter(Boolean);

	if (extras.length) {
		base += `, ${extras.join(', ')}`;
	}

	return base;
};
